import type { AxiosRequestConfig } from 'axios';
import api from '@/helpers/api';

/**
 * Every v2 endpoint answers inside a `{ data: … }` envelope;
 * these unwrap it so an API module names the URL and the payload type and nothing else.
 * An endpoint that answers with more than the envelope uses `api` directly.
 */
type Enveloped<T> = { data: T };

export function getData<T>(url: string, config?: AxiosRequestConfig) {
  return api.get<Enveloped<T>>(url, config).then(({ data }) => data.data);
}

export function postData<T>(
  url: string,
  body?: unknown,
  config?: AxiosRequestConfig
) {
  return api
    .post<Enveloped<T>>(url, body, config)
    .then(({ data }) => data.data);
}

export function patchData<T>(
  url: string,
  body?: unknown,
  config?: AxiosRequestConfig
) {
  return api
    .patch<Enveloped<T>>(url, body, config)
    .then(({ data }) => data.data);
}

export function putData<T>(
  url: string,
  body?: unknown,
  config?: AxiosRequestConfig
) {
  return api.put<Enveloped<T>>(url, body, config).then(({ data }) => data.data);
}

export function deleteData<T>(url: string, config?: AxiosRequestConfig) {
  return api.delete<Enveloped<T>>(url, config).then(({ data }) => data.data);
}

export { api };
